(() => {
  if (!document.body || !document.body.classList.contains('template-product')) return;

  const stickyRootSelector = [
    '[id*="sticky-atc" i]',
    '[id*="sticky_atc" i]',
    '[class*="sticky-atc" i]',
    '[class*="sticky_atc" i]',
    '[data-section-type*="sticky-atc" i]',
    '[data-block-type*="sticky-atc" i]'
  ].join(',');

  const normalise = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function markStickyButtons() {
    document.querySelectorAll(stickyRootSelector).forEach((root) => {
      root.querySelectorAll('button, [role="button"], a').forEach((control) => {
        const text = normalise(control.innerText || control.textContent || control.getAttribute('aria-label'));
        if (text.includes('add to cart') || text.includes('add to bag')) {
          control.classList.add('fc-sticky-atc-button');
        }
      });
    });
  }

  let queued = false;
  const queueMark = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      markStickyButtons();
    });
  };

  markStickyButtons();

  const observer = new MutationObserver(queueMark);
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('variant:change', queueMark);
  document.addEventListener('product:variant-change', queueMark);
})();
